<template>
  <div class="criteria-banner" :class="bannerClasses">
    <span class="criteria-text"><strong class="criteria-prefix">{{ criteriaPrefix }}</strong> {{ criteria }}</span>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  level: {
    type: String,
    required: true,
    validator: (value) => ['Apprentice', 'Professional', 'Coach', 'Master'].includes(value)
  },
  criteria: {
    type: String,
    required: true
  },
  criteriaPrefix: {
    type: String,
    required: true
  }
});

const bannerClasses = computed(() => {
  return `criteria-banner--${props.level.toLowerCase()}`;
});
</script>

<style scoped>
.criteria-prefix{
  color: grey;
  text-transform: capitalize;
}
.criteria-banner {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 6px;
  border: 1px solid;
  width: 100%;
  box-sizing: border-box;
}

.criteria-text {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}

/* Apprentice level colors */
.criteria-banner--apprentice {
  background-color: #FFF5D3;
  border-color: #E58700;
}

/* Professional level colors */
.criteria-banner--professional {
  background-color: #F3FFF9;
  border-color: #00B813;
}

/* Coach level colors */
.criteria-banner--coach {
  background-color: #EFFEFF;
  border-color: #00A3FF;
}

/* Master level colors */
.criteria-banner--master {
  background-color: #F2F3FF;
  border-color: #2E1EC1;
}
</style>
